import axiosInstance from "./api";
import { requestInterceptor, responseInterceptor } from "./interceptors";

import "../i18n/i18n";

axiosInstance.interceptors.request.use(requestInterceptor);
axiosInstance.interceptors.response.use(responseInterceptor);

export { executeAxiosRequest } from "./api";
export { axiosInstance as axios };
